import { configureStore } from "@reduxjs/toolkit";

import DetailReportSlice from "./DetailReportSlice";
import MapPositionSlice from "./MapPositionSlice"
import LanguageSlice from "./LanguageSlice";

export const store = configureStore({
    reducer: {
        detailReport : DetailReportSlice,
        mapPosition : MapPositionSlice,
        language : LanguageSlice,
    },
})